export default "__VITE_ASSET__C7RyN_gv__"